// extracted by mini-css-extract-plugin
module.exports = {"Content":"layout__Content__1x5Dd"};